// @flow
import type {SearchRequest, SearchRequestParam} from '../models/SearchRequest';

export const makeMinValueEnforcer = (searchRequest: SearchRequest) => (
    key: SearchRequestParam,
    minValue: number = 0
): SearchRequest => {
    return {
        ...((searchRequest[key] || searchRequest[key] === 0) &&
        parseInt(searchRequest[key], 10) > minValue
            ? {[key]: searchRequest[key]}
            : {})
    };
};
